module.exports = __webpack_public_path__ + "static/media/9.123d8bb4.jpg";